import { render, staticRenderFns } from "./authentication-forms.vue?vue&type=template&id=82843d8c&"
import script from "./authentication-forms.vue?vue&type=script&lang=js&"
export * from "./authentication-forms.vue?vue&type=script&lang=js&"
import style0 from "./authentication-forms.vue?vue&type=style&index=0&id=82843d8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports